(function($){

	// Initialize dynamic block preview (editor).
	if(window.acf){
		window.acf.addAction( 'render_block_preview/type=bar/block-accordion', initAccordion );
	}

	// Initialize each block on page load (front end).
    $('.bar-block-accordion').each(function(){
        initAccordion( $(this) );
    });

    /**
     * Inicialización del componente acordeón
     * 
     * @param accordion (obj) - Elemento acordeón (.bar-block-accordion)
     */
	function initAccordion(accordion){
		let questions = $('.bar-block-accordion__question',accordion);
		let answers = $('.bar-block-accordion__answer',accordion);

		questions.on('click',function(e){
			e.preventDefault();

			if( $(this).hasClass('is-open') ){
				$(this).removeClass('is-open').next('.bar-block-accordion__answer').slideUp(200);
			}else{
				questions.removeClass('is-open');
				answers.slideUp();

				$(this).addClass('is-open').next('.bar-block-accordion__answer').slideDown(200);
			}
		})
	}


})(jQuery)